
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        featureIndex: {
            type: Number,
            default: 0
        },
        featuresLength: {
            type: Number,
            default: 0
        }
    },
    emits: ['open-group', 'select-previous', 'select-next'],
    setup(props, { emit }) {
        const onOpenGroup = () => {
            emit('open-group')
        }

        const onSelectPrevious = () => {
            emit('select-previous')
        }

        const onSelectNext = () => {
            emit('select-next')
        }

        return {
            onOpenGroup,
            onSelectPrevious,
            onSelectNext
        }
    }
})
